import type { NodePropertySchema } from '../../../types/node-properties';

/**
 * MCP UI Renderer Node Schema
 * 
 * Configurable properties for UI rendering behavior.
 */
const schema: NodePropertySchema = {
  nodeType: 'mcp-ui-renderer',
  version: '1.0.0',
  
  properties: [
    {
      key: 'evoStyling',
      label: 'Evo Styling',
      type: 'boolean',
      default: true,
      required: false,
      description: 'Enable Evo Design System (EDS) theme integration. When enabled, injects EDS CSS variables and colors into rendered UI components. Automatically applies your app\'s theme colors (teal/cyan primary) to charts and visualizations.',
      placeholder: ''
    }
  ]
};

export default schema;
